import ProgressDay from '@/page/shweJourney/components/ProgressDay';
import backgroundImg from '@assets/web-v3-images/congratulation-popup.png';
import fireImg from '@assets/web-v3-images/fire.png';
import checkImg from '@assets/web-v3-images/icons/check.png';
import puzzleImg from '@assets/web-v3-images/icons/puzzlex5.png';
import reviveItemImg from '@assets/web-v3-images/image.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import SuccessTurnPopup from '.';
import Buttons from '../Buttons';

export default function StreakRestored({
  data = [],
  onOpenChange,
  open,
  handleClick = () => { },
  textBtn = '',
  dataClaim,
  checked,
}) {
  const { t } = useTranslation()
  return (
    <SuccessTurnPopup
      open={open}
      onOpenChange={onOpenChange}
      backgroundImg={backgroundImg}
      title={t('shwe_journey.streak_restored')}
      hiddenIconExit={false}
    >
      <div className="flex flex-col items-center justify-center text-center pt-10 sm:pt-20 md:pt-20 lg:pt-20 xl:pt-20">
        <div className="w-[100%] mt-[7%] mb-10">
          {/* --------------------- */}
          <div className="flex flex-col">
            <div className="relative inline-flex items-center justify-center">
              <img src={fireImg} className="block w-17 sm:w-25 h-auto" alt="fire" />
              <Text
                as="span"
                className="
							absolute
							top-1/2
							left-1/2
							-translate-x-1/2
							-translate-y-1/2
							text-[#FEFDF0]
							text-xl
							sm:text-3xl
							font-black
							leading-none
							pointer-events-none
							pt-[10%]
						"
                style={{
                  WebkitTextStroke: '1px #DE1900',
                }}
              >
                {data?.current_streak || 0}
              </Text>
            </div>
            <Text className="text-[rgba(147,47,25,1)] font-bold text-[18px] sm:text-[45px] md:text-[45px] lg:text-[45px] xl:text-[45px]">
              {t('shwe_journey.days_streak')}
            </Text>
            <Text
              className="text-[rgba(113,59,18,1)] font-medium 
						text-[13px] sm:text-[18px] md:text-[18px] lg:text-[18px] xl:text-[18px] z-11 pt-2
						"
            >
              {t("shwe_journey.your_missed_day_have_been_restored").replace("_LP_", dataClaim?.day_off_revived || 0)}
            </Text>
            <Text
              className="text-[rgba(113,59,18,1)] font-medium 
						text-[13px] sm:text-[18px] md:text-[18px] lg:text-[18px] xl:text-[18px] z-11 pt-1
						"
            >
              {t("shwe_journey.you_can_now_claim_today_day_reward").replace("_LP_", dataClaim?.current_streak || 0)}
            </Text>
          </div>
          {/* --------------------- */}
          <div className="w-full max-w-[220px] sm:max-w-[400px] h-[80px] sm:h-[125px] mx-auto overflow-hidden">
            <div
              style={{
                transform: 'scale(0.55)',
                transformOrigin: 'top left',
                width: (100 / 0.55) + '%',
                height: (100 / 0.55) + '%',
              }}
            >
              <ProgressDay data={data} />
            </div>
          </div>
          {/* --------------------- */}
          <div
            className="
						flex items-center gap-1 sm:gap-4
						rounded-2xl
						border-2 border-[#37D05A]
						bg-[#FFFBEA]
						p-2
						shadow-[0_2px_6px_rgba(0,0,0,0.08)]
						relative
						justify-center
						mb-3
						mx-[18%] sm:mx-[5%]
					"
          >
            <img
              src={checkImg}
              alt="check-img"
              className="w-7 h-7 object-contain shrink-0 absolute top-2 left-2"
            />
            <img
              src={checked === 'TURN' ? puzzleImg : reviveItemImg}
              alt="hammer"
              className="w-10 h-10 object-contain shrink-0"
            />
            <div className="flex flex-col text-left">
              <p className="text-[14px] sm:text-[20px] font-bold text-[rgba(113,59,18,1)]">
                {checked === 'TURN' ? t('shwe_journey.revived_to') : t('shwe_journey.revive_item')}{' '}
                <span className="text-[rgba(52,199,89,1)]">
                  {t('shwe_journey.day')} {dataClaim?.day_off_revived || 0}
                </span>
              </p>
              <p className="text-[12px] sm:text-[16px] italic font-medium text-[rgba(113,59,18,1)]">
                {dataClaim?.payment_amount || 0} {t('shwe_journey.turns_used')}
              </p>
            </div>
          </div>
          {/* --------------------- */}
          <div className="px-[18%] sm:px-[5%]">
            <Buttons handleClick={handleClick} textBtn={textBtn} />
          </div>
        </div>
      </div>
    </SuccessTurnPopup>
  );
}
